import React, { PureComponent } from 'react'
import { Button, H1 } from "@driftt/tide-core"
import { getDefaultConfig } from 'utils/password'
import PasswordInput from 'components/PasswordInput'
import EmailInput from 'components/EmailInput'

import './style.css'

const canSave = ({ isPasswordValid, isEmailValid, email, isInvoiced, solvedCaptcha }) => {
  return isPasswordValid && isEmailValid && !!email.length && (!isInvoiced || solvedCaptcha)
}

class DealCreateAccountStep extends PureComponent {
  componentDidMount() {
    this.props.onInitPasswordCheck(this.props.password)
  }

  render() {
    const {
      email,
      password,
      buttonName,
      isProcessing,
      onNextClicked,
      onEmailUpdated,
      onPasswordUpdated,
      isEmailValid,
      isPasswordValid,
      emailHasInvalidDomain,
      isInvoiced,
      solvedCaptcha
    } = this.props

    return (
      <div className="deal-create-account-step">
        <H1>Create account</H1>
        <div className="deal-create-account-step-form">
          <EmailInput
            placeholder={"you@company.com"}
            personal={emailHasInvalidDomain}
            onChange={onEmailUpdated}
            value={email}
            label={'Email address'}
            unique={true}
            valid={isEmailValid}
            type={"email"}
            hideError={false}
            createOrgError={false}
          />
          <PasswordInput
            value={password}
            onChange={onPasswordUpdated}
            passwordConfig={getDefaultConfig()}
            passwordConfigFetched={true}
            passwordUpdateStatus={null}
          />
          {isInvoiced && (
            <div className="recaptcha-container">
              <div id="g-recaptcha" />
            </div>
          )}
          <Button size="large" loading={isProcessing}
            type="primary"
            disabled={!canSave({ isPasswordValid, isEmailValid, email, isInvoiced, solvedCaptcha })}
            onClick={onNextClicked}>
            {buttonName}
          </Button>
        </div>
      </div>
    )
  }
}

export default DealCreateAccountStep
